<template>
  <div class="min-h-screen flex flex-col items-center justify-center p-10 background-image">
    <div class="max-w-sm w-full text-left space-y-8">
      <div class="space-y-6">
        <div class="flex items-center flex-row gap-2">
          <Logo :width="100" color="#FFFFFF" />
          <div v-if="runClub === 'spaceship'" class="text-white text-xl">
            +
          </div>
          <div v-if="runClub === 'spaceship'" class="text-white text-2xl">
            <SpaceshipLogo color="#FFFFFF" :width="145" />
          </div>
        </div>

        <div class="flex items-center justify-start space-x-4 pt-4 mb-8">
          <img src="/3cnl/images/frame-logo-beta.svg" alt="3CNL Logo" class="logo">
        </div>

        <p class="text-xl paragraph font-light">
          Visualize and Share<br />
          {{ runClub === 'spaceship' ? 'Your Spaceship Experience' : 'Your Strava Runs' }}
        </p>

        <div class="flex justify-center items-center">
          <img src="/3cnl/images/landing/map-login.svg" class="map-regular" />
        </div>

        <div class="strava-button-wrapper">
          <a
            class="inline-block strava-button"
            href="/api/strava/redirect"
          >
            <img src="/3cnl/images/landing/connect-with-strava-text.svg" alt="Connect with Strava">
          </a>
        </div>

        <div class="social">
          <a href="https://strava.app.link/g1f2LXzmhUb" target="_blank">
            <img src="/3cnl/images/landing/strava-icon.svg" alt="Strava" />
          </a>
          <a href="https://instagram.com/3cnl.cc" target="_blank">
            <img src="/3cnl/images/landing/ig-icon.svg" alt="Instagram" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from '#/shared/components/logo.vue';
import SpaceshipLogo from '#/shared/components/spaceship-logo.vue';
import {
  stravaAthleteAtom,
  stravaAccessTokenAtom,
} from '#/entity/strava/strava-model';
import { reatomRef } from '@reatom/npm-vue';
import { navigate } from 'vike/client/router';
import { onMounted } from 'vue';
import { runClubModelAtom } from '#/features/run-club/run-club-model';

const stravaAthlete = reatomRef(stravaAthleteAtom);
const stravaAccessToken = reatomRef(stravaAccessTokenAtom);

const runClub = reatomRef(runClubModelAtom);

onMounted(() => {
  if (stravaAthlete.value && stravaAccessToken.value) {
    navigate('/strava/activities');
  }
});
</script>

<style scoped>
.background-image {
  background-image: url('/3cnl/images/bg/bg_image.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Fallback for browsers that don't support WebP */
@supports not (background-image: url('/3cnl/images/bg/bg_image.webp')) {
  .background-image {
    background-image: url('/3cnl/images/bg/bg_image.png');
  }
}

/* Modern browsers with image-set support */
@supports (background-image: image-set(url('/3cnl/images/bg/bg_image.webp') 1x)) {
  .background-image {
    background-image: 
      -webkit-image-set(
        url('/3cnl/images/bg/bg_image.webp') 1x,
        url('/3cnl/images/bg/bg_image.png') 1x
      );
    background-image: 
      image-set(
        url('/3cnl/images/bg/bg_image.webp') 1x,
        url('/3cnl/images/bg/bg_image.png') 1x
      );
  }
}

.strava-button-wrapper {
  display: block;
  max-width: 290px;
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
}


.strava-button {
  border: none;
  display: block;
  background-color: #FD4B01;
  border-radius: 25px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.strava-button:hover {
  opacity: 0.8;
}

.logo {
  width: 200px;
}

.second-paragraph svg {
  width: 60px;
  display: inline;
  vertical-align: text-bottom;
  position: relative;
  top: 1px;
}

.paragraph {
  color: #ffffff;
}

.social {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2vh;
}
.social a img {
  width: 24px;
  height: 24px;
}

.map-regular {
  display: block;
  aspect-ratio: 295 / 260;
}
</style>
